/**
 * @generated SignedSource<<34d56e882bfd827d083e209f30a86d2f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedPromoModule_componentModule$data = {
  readonly cmsDisplayTitle: string | null;
  readonly messages: {
    readonly ctaCopy: string | null;
    readonly ctaUrl: string | null;
    readonly items: ReadonlyArray<{
      readonly cmsId: number | null;
      readonly imageWidth?: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"HpSharedPromoModulePromoItem_promotion" | "promoTracking_promotion">;
    } | null> | null;
    readonly title: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"promoTracking_messages">;
  } | null;
  readonly " $fragmentType": "HpSharedPromoModule_componentModule";
};
export type HpSharedPromoModule_componentModule$key = {
  readonly " $data"?: HpSharedPromoModule_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedPromoModule_componentModule">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LinkData",
    "kind": "LinkedField",
    "name": "linkData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "path",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile"
    },
    {
      "kind": "RootArgument",
      "name": "userType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedPromoModule_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cmsDisplayTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userType",
          "variableName": "userType"
        }
      ],
      "concreteType": "PromoModuleMessages",
      "kind": "LinkedField",
      "name": "messages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ctaUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ctaCopy",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PromoItem",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cmsId",
              "storageKey": null
            },
            {
              "condition": "isMobile",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "imageWidth",
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "promoTracking_promotion",
              "selections": (v0/*: any*/),
              "args": null,
              "argumentDefinitions": []
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "HpSharedPromoModulePromoItem_promotion"
            }
          ],
          "storageKey": null
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "promoTracking_messages",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PromoItem",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PromoModule",
  "abstractKey": null
};
})();

(node as any).hash = "e6a6e9482e54745a152de1b1605995b7";

export default node;
